import styled from '@emotion/styled';

const AdUnder = styled('div')({
  marginTop: 0,
});

// IHRWEB-15411 poorly named ? doesn't appear to be ad. just "under" ad
// Web-Ads 2.0 implementation (MP)
export default AdUnder;
